<template>
  <div class="project-create outer-layer">
    <div
      v-for="(item, key) in project_form_config"
      :key="key"
      style="margin: 20px 0"
    >
      <el-divider
        v-if="key === 'basic_set_form' || project_form_config.basic_set_form.config.advertiser_id.value"
        content-position="left"
      >
        <h3>{{ item.title }}</h3>
      </el-divider>
      <app-form
        v-if="key === 'basic_set_form' || project_form_config.basic_set_form.config.advertiser_id.value"
        :ref="'project_form'"
        v-loading="is_loading"
        :form-data="item.config"
        :submit-request="onSubmit"
        :is-show-button="false"
        default-label-width="120px"
      >
        <template #custom="{form_item, form_key}">
          <!-- 微信/字节小游戏 -->
          <div v-if="form_key === 'micro_app_instance_id'">
            <el-button type="primary" :disabled="is_edit" @click="openMiniProgramAssets">选择小游戏</el-button>
            <div v-if="form_item.value">
              {{ is_wechat_game && is_edit ? `${JSON.parse(form_item.value)?.micro_app_instance_id}` : `${JSON.parse(form_item.value)?.asset_name}(${JSON.parse(form_item.value)?.micro_app_id})` }}
            </div>
          </div>
          <!-- 定向包 -->
          <audience
            :form-item="form_item"
            :form-key="form_key"
            :advertiser-id="project_form_config.basic_set_form.config.advertiser_id.value"
          />

          <!-- 投放时间段 -->
          <div v-if="form_key === 'schedule_time'" class="launch-style">
            <keep-alive include="schedule-time">
              <schedule-time
                ref="ScheduleTime"
                preele="outer-layer"
                :time="form_item.value"
              />
            </keep-alive>
          </div>
          <span v-if="form_key === 'download_url'">
            <el-button
              type="primary"
              @click="openAssetBox"
            >
              选择应用
            </el-button>
            <div>
              <span>{{ form_item.app_name }}</span>
            </div>
          </span>

        </template>
      </app-form>
    </div>

    <div class="floor-button">
      <el-button @click="onCancelForm">取消</el-button>
      <el-button :loading="is_loading" type="primary" @click="onConfirmForm">确定</el-button>
    </div>

    <!-- 选择事件资产弹框 -->
    <event-asset-box
      v-if="event_asset_box_params.is_show"
      :is-open="event_asset_box_params.is_show"
      :tablep="event_asset_box_params.tablep"
      @confirm="eventAssetConfirm"
      @cancel="event_asset_box_params.is_show = false"
    />

    <el-dialog
      v-if="mini_program_assets_dialog_config.is_show"
      :visible.sync="mini_program_assets_dialog_config.is_show"
      v-bind="mini_program_assets_dialog_config.dialog_props"
    >
      <mini-program-assets
        v-if="mini_program_assets_dialog_config.is_show"
        :mg-type="mini_program_assets_dialog_config.mg_type"
        v-bind="mini_program_assets_dialog_config.getters.getAssetsProps()"
        @confirm="miniProgramAssetsConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import getJrttProjectConfig from '@/tools/form/model/jrtt/project-config';
import { formDataAssign } from '@/tools/form';

import AppManagement from '@/api/tool/app-management/jrtt';
const appManagement = new AppManagement();

import EventManager from '@/api/tool/event-manager/jrtt';
const eventManager = new EventManager();

// 查询行为兴趣类目
import InterestActionResource from '@/api/tool/interest-action/jrtt';
const interestActionResource = new InterestActionResource();

import { getOptimizedGoalV2Api } from '@/api/tool/event-manager/optimized-goal-v2/jrtt';
import { getDeepBidTypeApi } from '@/api/tool/event-manager/deep-bid-type/jrtt';
import { getDistrictApi } from '@/api/tool/district/jrtt';
import { getMediasListApi } from '@/api/medias';
import { createProjectApi, updateProjectApi, getProjectInfoApi } from '@/api/project/jrtt';
import store from '@/store';
import { clone } from '@/utils';
import { isObject } from '@/utils/is';

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
    'schedule-time': () => import('@/components/schedule-time'),
    'audience': () => import('./audience'),
    'event-asset-box': () => import('./event-asset-box'),
    'mini-program-assets': () => import('@/views/superior/jrtt/components/mini-program-assets'),
  },
  props: {
    /** 项目数据 */
    projectData: {
      type: [Object, null],
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      districts_map: {},
      is_loading: false,
      /** 是否为编辑 */
      is_edit: false,
      /** 提交项目参数 */
      project_params: {},

      /** 事件弹框参数 */
      event_asset_box_params: {
        is_show: false,
        tablep: {},
        key: '',
        checkList: [],
      },

      /** 项目表单配置 */
      project_form_config: {
        // 基础设置-表单配置
        basic_set_form: {
          title: '基础设置',
          config: getJrttProjectConfig([
            'advertiser_id',
            'landing_type',
            'app_promotion_type',
            'delivery_mode',
            'marketing_goal',
            'ad_type',
            'name',
          ]),
        },
        // 投放内容与目标-表单配置
        target_form: {
          title: '投放内容与目标',
          config: getJrttProjectConfig([
            'platform',
            'download_url',
            'download_type',
            'download_mode',
            'launch_type',
            'open_url',
            'ulink_url',
            'subscribe_url',
            'micro_promotion_type',
            'micro_app_instance_id',
          ]),
        },
        // 优化目标-表单配置
        optimize_form: {
          title: '优化目标',
          config: getJrttProjectConfig([
            'optimize_goal',
          ]),
        },
        // 广告版位-表单配置
        delivery_range_form: {
          title: '广告版位',
          hidden: false,
          config: getJrttProjectConfig([
            'delivery_range',
          ]),
        },
        // 广告版位-表单配置
        audience_form: {
          title: '定向包',
          config: getJrttProjectConfig([
            'audience',
          ]),
        },
        // 排期与预算-表单配置
        delivery_setting_form: {
          title: '排期与预算',
          config: getJrttProjectConfig([
            'delivery_setting',
          ]),
        },
        // 渠道
        channel_form: {
          title: '渠道',
          config: getJrttProjectConfig([
            'channel',
          ]),
        },
      },
      /** 小程序资产弹窗配置 */
      mini_program_assets_dialog_config: {
        is_show: false,
        mg_type: '', // 小游戏类型 - 微信、字节
        dialog_props: {
          title: '请选择事件资产',
          width: '800px',
          appendToBody: true,
        },
        getters: {
          getAssetsProps: () => {
            const { basic_set_form: { config: { advertiser_id, landing_type, ad_type }}} = this.project_form_config;
            return {
              assetType: 'MINI_PROGRAME', // 该【PROGRAME】单词为官方写错，后端v1版本暂时与官方文档一致
              advertiserId: advertiser_id.value,
              landingType: landing_type.value,
              adType: ad_type.value,
            };
          },
        },
      },
    };
  },
  computed: {
    is_wechat_game() {
      const { micro_promotion_type } = this.project_form_config.target_form.config;
      return micro_promotion_type.value === 'WECHAT_GAME';
    },
  },
  async created() {
    this.basicSetEvent();
    this.getMediasList();

    // 是否存在项目ID
    if (this.projectData?.id) {
      this.is_loading = true;
      this.is_edit = true;
      getProjectInfoApi(this.projectData.id).then(async(res) => {
        const temp_project_data = res;
        const {
          advertiser_id,
          landing_type,
        } = this.project_form_config.basic_set_form.config;
        const { download_url } = this.project_form_config.target_form.config;
        advertiser_id.value = this.projectData.advertiser_id;
        download_url.value = this.projectData.download_url;

        const { event_asset } = temp_project_data;
        const map_tuple = [
          // 小游戏
          [
            () => temp_project_data?.landing_type === 'MICRO_GAME' && temp_project_data?.micro_promotion_type,
            () => {
              const { micro_promotion_type } = this.project_form_config.target_form.config;
              micro_promotion_type.backup_value = temp_project_data.micro_promotion_type;
            },
          ],
          // 是否存在微信小游戏
          [
            () => temp_project_data?.landing_type === 'MICRO_GAME' && temp_project_data?.micro_promotion_type === 'WECHAT_GAME' && temp_project_data?.micro_app_instance_id,
            () => {
              temp_project_data.micro_app_instance_id = JSON.stringify({ micro_app_instance_id: temp_project_data.micro_app_instance_id });
            },
          ],
          // 是否存在字节小游戏
          [
            () => temp_project_data?.landing_type === 'MICRO_GAME' && temp_project_data?.micro_promotion_type === 'BYTE_GAME' && temp_project_data?.micro_app_instance_id && isObject(event_asset),
            () => {
              temp_project_data.micro_app_instance_id = JSON.stringify(event_asset);
            },
          ],
        ];
        map_tuple.forEach(([m, n]) => m() && n());

        // 存在应用名称就显示出来
        if (this.projectData.app_name) {
          download_url.app_name = this.projectData.app_name;
        }

        const is_has_audience = !!temp_project_data?.audience;

        // 定向包 -【自定义人群包】
        if (is_has_audience) {
          const { retargeting_tags_include, retargeting_tags_exclude } = temp_project_data.audience;
          if (retargeting_tags_include || retargeting_tags_exclude) {
            const crowd_pack = {
              include: retargeting_tags_include || [],
              exclude: retargeting_tags_exclude || [],
            };
            Object.assign(temp_project_data.audience, {
              crowd_pack,
            });
            delete temp_project_data.audience.retargeting_tags_include;
            delete temp_project_data.audience.retargeting_tags_exclude;
          }
        }

        for (const key in this.project_form_config) {
          formDataAssign(this.project_form_config[key].config, temp_project_data);
        }

        // 投放时间转换绑定数据格式
        const { start_time } = this.project_form_config?.delivery_setting_form?.config?.delivery_setting?.children;
        if (temp_project_data.delivery_setting?.start_time && temp_project_data.delivery_setting?.end_time) {
          start_time.value = [temp_project_data.delivery_setting.start_time, temp_project_data.delivery_setting.end_time];
        }

        await this.initConfig();
        /** 主动触发推广目标改变事件 */
        landing_type.on.change(temp_project_data.landing_type);
      }).finally(() => {
        this.is_loading = false;
      });
    } else {
      this.is_edit = false;
    }
  },
  methods: {
    /** 基础设置事件监听 */
    basicSetEvent() {
      const {
        advertiser_id,
        landing_type,
        app_promotion_type,
        delivery_mode,
      } = this.project_form_config.basic_set_form.config;
      const { audience } = this.project_form_config.audience_form.config;
      const { platform, download_url, download_type, download_mode, launch_type, open_url, ulink_url, subscribe_url, micro_promotion_type, micro_app_instance_id } = this.project_form_config.target_form.config;
      const { external_action, deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
      const { deep_bid_type, bid_type, budget_mode, budget_optimize_switch, cpa_bid, deep_cpabid } = this.project_form_config.delivery_setting_form.config.delivery_setting.children;

      if (landing_type && app_promotion_type) {
        // 推广子目标事件监听
        app_promotion_type.on = {
          change: this.appPromotionTypeChange,
        };

        // 广告账号事件监听
        advertiser_id.on = {
          change: this.advertiserIdChange,
        };

        // 平台事件监听
        platform.on = {
          change: (val) => {
            if (platform.value === val) {
              this.getAssetsList();
            }
            audience.children.platform.value = [platform.value];
          },
        };

        // 行为兴趣事件监听
        audience.children.interest_action_mode.on = {
          change: this.interestActionChange,
        };

        audience.children.action_days.on = {
          change: (val) => {
            if (val) {
              this.updateInterestAction();
            }
          },
        };

        // 下载链接事件监听
        download_url.on = {
          change: this.downloadUrlChange,
        };

        // 优化目标事件监听
        external_action.on = {
          change: (val) => {
            if (val) {
              deep_external_action.value = '';
            }

            const index = external_action.options.findIndex(item => {
              return item.value === external_action.value;
            });

            if (index !== -1) {
              const temp_deep_goals = external_action.options[index]?.deep_goals;
              const deep_bid_types = external_action.options[index]?.deep_bid_types;
              if (temp_deep_goals) {
                deep_external_action.options = temp_deep_goals.map(item => {
                  return {
                    label: item.optimization_name,
                    value: item.deep_external_action,
                    deep_bid_type: item.deep_bid_type,
                    deep_bid_type_name: item.deep_bid_type_name,
                  };
                });
                deep_external_action.hidden = false;
              } else {
                deep_external_action.hidden = true;
              }

              if (deep_bid_types?.length) {
                deep_bid_type.options = deep_bid_types.map(item => {
                  return {
                    label: item.name,
                    value: item.deep_bid_type,
                  };
                });

                deep_bid_type.hidden = false;
              } else {
                deep_bid_type.options = [];
                deep_bid_type.hidden = true;
              }
            }

            /** 如果优化目标等于 AD_CONVERT_TYPE_PAY，不管获取可用优化目标接口有没有返回深度优化目标，都需要请求该接口 */
            if (external_action.value === 'AD_CONVERT_TYPE_PAY') {
              this.setDeepBidTypeProperty();
            }
            deep_bid_type?.on?.change?.();
            this.setRoiGoalProperty();

            // 优化目标事件监听
            deep_external_action.on = {
              change: () => {
                const index = deep_external_action.options.findIndex(item => {
                  return item.value === deep_external_action.value;
                });

                if (index !== -1) {
                  const temp_deep_bid_type = deep_external_action.options[index]?.deep_bid_type;
                  const temp_deep_bid_type_name = deep_external_action.options[index]?.deep_bid_type_name;
                  if (temp_deep_bid_type) {
                    deep_bid_type.options = [{
                      label: temp_deep_bid_type_name,
                      value: temp_deep_bid_type,
                    }];

                    deep_bid_type.value = temp_deep_bid_type;
                    deep_bid_type.hidden = false;
                  } else {
                    deep_bid_type.hidden = true;
                  }
                } else {
                  external_action.on.change();
                  deep_bid_type?.on?.change?.();
                }

                /** 如果深度优化目标有值*/
                if (deep_external_action.value) {
                  this.setDeepBidTypeProperty();
                } else {
                  deep_bid_type.hidden = true;
                }
                deep_bid_type?.on?.change?.();
                this.setRoiGoalProperty();
              },
            };
          },
        };

        /** 深度优化方式事件监听 */
        deep_bid_type.on = {
          change: () => {
            /** 深度优化出价，deep_bid_type = DEEP_BID_MIN 时必填。取值范围：0.1~10000元 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错 */
            const is_deep_bid_min = deep_bid_type.value === 'DEEP_BID_MIN';
            const is_no_bid = bid_type.value === 'NO_BID';
            /** 深度优化方式是【显示】且值为【DEEP_BID_MIN】时显示【深度优化出价】 */
            deep_cpabid.hidden = !(is_deep_bid_min && !deep_bid_type.hidden);
            if (is_no_bid) {
              deep_cpabid.hidden = true;
            }
          },
        };

        // 推广目的事件监听
        landing_type.on = {
          change: async(val) => {
            const is_micro_game = val === 'MICRO_GAME';
            /** 推广目的为小游戏时，推广子目标控制隐藏 */
            app_promotion_type.hidden = is_micro_game;
            /** 推广目的为小游戏时,投放内容与目标模块显示小游戏类型 */
            micro_promotion_type.options = this.$store.getters.jrttEnum.api_2_micro_promotion_type || [];
            micro_promotion_type.hidden = !is_micro_game;

            /** 推广目的为小游戏时,已安装用户只支持 不限（UNLIMITED）*/
            const { audience: { children: { hide_if_exists }}} = this.project_form_config.audience_form.config;
            is_micro_game && (hide_if_exists.value = 'UNLIMITED');
            hide_if_exists.options.forEach(opt => (opt.disabled = (is_micro_game && opt.value !== `UNLIMITED`)));

            /** 推广目标为小游戏的时候, 投放内容与目标只显示`小游戏类型` */
            [subscribe_url, ulink_url, open_url, launch_type, download_url, download_type, download_mode, platform].forEach(field => (field.hidden = is_micro_game));

            /** 显示【投放模式】 */
            delivery_mode.hidden = false;

            /** 推广目标不为小游戏时，主动触发推广子目标改变事件，初始化投放内容与目标的表单显示 */
            !is_micro_game && this.appPromotionTypeChange();

            /** 推广目标切换时，主动触发广告主账号改变事件以获取最新的资产列表和优化目标数据 */
            advertiser_id.on.change();

            /** 隐藏资产列表 */
            const { optimize_goal: { children: { asset_ids }}} = this.project_form_config.optimize_form.config;
            asset_ids.hidden = is_micro_game;

            /** 推广目标为小游戏的时候，定向包-平台允许自由选择 */
            audience.children.platform.disabled = !is_micro_game;
            audience.children.platform.value = [platform.value];

            this.resetDeliveryRangeForm();
            this.setAudienceFormProperty();
            this.setDeliverySettingFormProperty();
            this.setRoiGoalProperty();

            micro_promotion_type.on.change();
          },
        };

        // 【小游戏类型】事件监听
        micro_promotion_type.on = {
          change: () => {
            const is_micro_game = landing_type.value === 'MICRO_GAME';
            const is_byte_game = micro_promotion_type.value === 'BYTE_GAME';
            const is_wechat_game = micro_promotion_type.value === 'WECHAT_GAME';
            micro_app_instance_id.hidden = !(is_micro_game && (is_byte_game || is_wechat_game));
            micro_app_instance_id.label = is_wechat_game ? '微信小游戏' : '字节小游戏';
            micro_app_instance_id.rules.message = is_wechat_game ? '请选择微信小游戏' : '请选择字节小游戏';
            if (micro_promotion_type.value !== micro_promotion_type.backup_value) {
              micro_promotion_type.backup_value = micro_promotion_type.value;
              micro_app_instance_id.value = '';
            }
            this.getMiniOptimizedGoal();
          },
        };

        /** 投放模式的事件监听 */
        delivery_mode.on = {
          change: () => {
            this.setInventoryCatalogProperty();
            this.setAudienceFormProperty();
            this.setDeliverySettingFormProperty();
            this.getMiniOptimizedGoal();
            this.setRoiGoalProperty();

            const { deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
            deep_external_action?.on?.change?.();
          },
        };

        /** 竞价策略事件处理 */
        bid_type.on = {
          change: () => {
            const is_custom = budget_mode.value === 'BUDGET_MODE_DAY';
            const is_no_bid = bid_type.value === 'NO_BID';
            const is_procedural = delivery_mode.value === 'PROCEDURAL';

            budget_optimize_switch.disabled = !!(!delivery_mode.hidden && is_procedural);
            /** 当bid_type=NO_BID且BUDGET=BUDGET_MODE_DAY时,“预算择优分配”必填; */
            budget_optimize_switch.hidden = !(is_custom && is_no_bid);

            /** 当delivery_mode = PROCEDURAL && landing_type = APP/MICRO_GAME时不支持OFF */
            budget_optimize_switch.value = (!delivery_mode.hidden && is_procedural) ? 'ON' : budget_optimize_switch.value;

            /** 目标转化出价/预期成本。当 bid_type = NO_BID时，不支持该字段；当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME/LINK时必填； */
            cpa_bid.hidden = !(!delivery_mode.hidden && is_procedural && !is_no_bid && (landing_type.value === 'APP' || landing_type.value === 'MICRO_GAME'));

            /** 竞价策略为最大转化投放时，不支持深度转化ROI系数配置 */
            this.setRoiGoalProperty();

            deep_bid_type?.on?.change?.();
          },
        };
      }
    },

    /**
     * 初始化配置
     */
    async initConfig() {
      let event_list = [];

      // 编辑禁用
      if (this.is_edit) {
        const { external_action, deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
        const { bid_type, deep_bid_type } = this.project_form_config.delivery_setting_form.config.delivery_setting.children;
        const { inventory_catalog, inventory_type } = this.project_form_config.delivery_range_form.config.delivery_range.children;
        const {
          platform,
          download_url,
          download_type,
          micro_promotion_type,
        } = this.project_form_config.target_form.config;

        const { landing_type } = this.project_form_config.basic_set_form.config;
        landing_type.disabled = true;
        external_action.props.disabled = true;
        deep_external_action.props.disabled = true;
        deep_bid_type.disabled = true;
        inventory_catalog.disabled = true;
        inventory_type.props.disabled = true;
        platform.disabled = true;
        download_url.props.disabled = true;
        download_type.disabled = true;
        bid_type.disabled = true;
        micro_promotion_type.props.disabled = true;

        const {
          /** 设备 */
          device,
          device_brand,
          phone_prices,
          launch_price,

          /** 人群包 */
          crowd_pack_button,
          crowd_pack,
        } = this.project_form_config.audience_form.config.audience.children;

        device_brand.hidden = device_brand.value.length === 0;
        device.value = device_brand.value.length > 0 ? 'CHOOSE_BRAND' : null;

        launch_price.hidden = launch_price.value.length === 0;
        phone_prices.value = launch_price.hidden ? null : 'CUSTOM';

        crowd_pack_button.value = (crowd_pack.value.include.length > 0 || crowd_pack.value.exclude.length > 0) ? 'CUSTOM' : null;
      }

      for (const key in this.project_form_config) {
        const config = this.project_form_config[key]?.config;
        if (config) {
          const change_list = this.getChangeList(config);

          if (change_list.length){
            event_list = [
              ...event_list,
              ...change_list,
            ];
          }
        }
      }

      this.is_loading = true;
      try {
        for (let i = 0; i < event_list.length; i++) {
          await event_list[i]();
        }
      } catch (error) {
        console.log(error);
      }

      this.is_loading = false;
    },

    /**
     * 获取change方法列表
     */
    getChangeList(config) {
      let change_list = [];
      for (const config_key in config) {
        const item = config[config_key];
        if (config[config_key].children) {
          const config_list = this.getChangeList(item.children);
          change_list = [
            ...change_list,
            ...config_list,
          ];
        } else if (item.on?.change){
          change_list.push(item.on.change);
        }
      }

      return change_list;
    },

    /**
     * 广告主账号选中事件
     */
    async advertiserIdChange() {
      const {
        advertiser_id,
      } = this.project_form_config.basic_set_form.config;

      if (!advertiser_id.value) {
        return;
      }
      await this.getAssetsList();
      await this.getMiniOptimizedGoal();
      await this.initDistrictTasks();
    },

    /**
     * 下载链接选择事件
     */
    async downloadUrlChange(val) {
      const {
        ad_type,
        advertiser_id,
        landing_type,
        app_promotion_type,
        delivery_mode,
      } = this.project_form_config.basic_set_form.config;
      const { optimize_goal } = this.project_form_config.optimize_form.config;
      const { download_url, platform } = this.project_form_config.target_form.config;
      let temp_asset = download_url.options.filter(item => item.value === download_url.value)[0];
      if (!temp_asset) {
        const asset_id = optimize_goal.children.asset_ids?.value[0];
        temp_asset = {
          asset_id: asset_id,
          package_name: optimize_goal.children.asset_ids.options.filter(item => item.value === asset_id)[0]?.package_name,
        };
      }

      // 被动触发清空值
      if (val !== undefined) {
        optimize_goal.children.external_action.value = '';
      }

      if (!temp_asset) {
        return;
      }

      optimize_goal.children.asset_ids.value = [temp_asset.asset_id];

      optimize_goal.children.deep_external_action.hidden = true;

      const is_app = landing_type.value === 'APP';
      is_app && this.getOptimizedGoalV2({
        advertiser_id: advertiser_id.value,
        ad_type: ad_type.value,
        landing_type: landing_type.value,
        asset_type: landing_type.value,
        app_type: platform.value,
        app_promotion_type: app_promotion_type.value,
        package_name: temp_asset?.package_name,
        ...(!delivery_mode.hidden && { delivery_mode: delivery_mode.value }),
      });
    },

    /**
     * 打开资产框
     */
    openAssetBox() {
      const {
        advertiser_id,
        landing_type,
      } = this.project_form_config.basic_set_form.config;
      const { platform } = this.project_form_config.target_form.config;

      this.event_asset_box_params.tablep = {
        advertiser_id: advertiser_id.value,
        landing_type: landing_type.value,
        app_type: platform.value,
      };

      this.event_asset_box_params.is_show = true;
    },

    /** 设置渠道号 */
    setChannelCode(asset_data) {
      const { channel_id = '' } = asset_data;
      const { alias } = this.project_form_config.channel_form.config.channel.children;
      alias.value = channel_id;
    },

    // 事件弹框确定回调
    async eventAssetConfirm(temp_asset) {
      const {
        ad_type,
        advertiser_id,
        landing_type,
        app_promotion_type,
        delivery_mode,
      } = this.project_form_config.basic_set_form.config;
      const { optimize_goal } = this.project_form_config.optimize_form.config;
      const { download_url, platform } = this.project_form_config.target_form.config;

      this.event_asset_box_params.is_show = false;
      download_url.value = temp_asset.download_url;
      download_url.app_name = temp_asset.name;

      optimize_goal.children.asset_ids.value = [temp_asset.asset_id];
      optimize_goal.children.deep_external_action.hidden = true;
      this.setChannelCode(temp_asset);
      this.getOptimizedGoalV2({
        advertiser_id: advertiser_id.value,
        ad_type: ad_type.value,
        landing_type: landing_type.value,
        asset_type: landing_type.value,
        app_type: temp_asset?.app_type ? temp_asset?.app_type : platform.value,
        app_promotion_type: app_promotion_type.value,
        package_name: temp_asset?.package_name,
        ...(!delivery_mode.hidden && { delivery_mode: delivery_mode.value }),
      });
    },

    /**
     * 推广子目标选中事件
     * @param {String} val 选中值
     */
    appPromotionTypeChange() {
      const {
        app_promotion_type,
        delivery_mode,
      } = this.project_form_config.basic_set_form.config;
      const val = app_promotion_type.value;

      const {
        download_url,
        download_type,
        download_mode,
        launch_type,
        open_url,
        ulink_url,
        subscribe_url,
      } = this.project_form_config.target_form.config;
      const IS_LAUNCH_OR_DOWNLOAD = val === 'DOWNLOAD' || 'LAUNCH';
      const IS_LAUNCH = val === 'LAUNCH';
      const IS_RESERVE = val === 'RESERVE';
      const IS_DOWNLOAD = val === 'DOWNLOAD';

      download_url.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      download_type.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      download_mode.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      launch_type.hidden = !IS_LAUNCH;
      open_url.hidden = !IS_LAUNCH;
      ulink_url.hidden = !IS_LAUNCH;
      subscribe_url.hidden = !IS_RESERVE;

      /** 应用下载或预约下载的时候显示 */
      delivery_mode.hidden = !(IS_DOWNLOAD || IS_RESERVE);

      this.resetDeliveryRangeForm();
      this.setAudienceFormProperty();
      this.setDeliverySettingFormProperty();
      this.setRoiGoalProperty();
    },
    // 提交表单
    onSubmit(params) {
      const crowd_pack = params?.audience?.crowd_pack;

      // 【自定义人群包】
      if (crowd_pack) {
        const { include, exclude } = crowd_pack;
        // 定向
        if (include.length) {
          Object.assign(params.audience, {
            retargeting_tags_include: include.map(item => item.custom_audience_id),
          });
        }
        // 排除
        if (exclude.length) {
          Object.assign(params.audience, {
            retargeting_tags_exclude: exclude.map(item => item.custom_audience_id),
          });
        }
        delete params.audience.crowd_pack;
      }

      if (params.delivery_setting) {
        const { start_time } = params.delivery_setting;
        if (start_time?.length) {
          params.delivery_setting['start_time'] = start_time[0];
          params.delivery_setting['end_time'] = start_time[1];
        }

        if (this.$refs?.ScheduleTime?.[0]) {
          params.delivery_setting.schedule_time = this.$refs.ScheduleTime[0].addTime();
        }
      }

      this.project_params = {
        ...this.project_params,
        ...params,
      };
    },
    // 取消表单
    onCancelForm: function() {
      this.$emit('cancel');
    },
    // 提交表单
    onConfirmForm: async function() {
      let is_succeed = false;
      this.project_params = {};
      for (let i = 0; i < this.$refs.project_form.length; i++) {
        const item = this.$refs.project_form[i];
        is_succeed = await item.confirm();
        if (!is_succeed) {
          break;
        }
      }
      const { landing_type, micro_promotion_type, micro_app_instance_id } = this.project_params;
      const map_tuple = [
        // 是否存在微信/字节小游戏
        [
          () => landing_type === 'MICRO_GAME' && ['WECHAT_GAME', 'BYTE_GAME'].includes(micro_promotion_type) && micro_app_instance_id,
          () => {
            const data = JSON.parse(micro_app_instance_id);
            this.project_params.micro_app_instance_id = data.micro_app_instance_id;
            micro_promotion_type === 'BYTE_GAME' && Object.assign(this.project_params.optimize_goal, { asset_ids: [data.asset_id] });
          },
        ],
      ];
      map_tuple.forEach(([m, n]) => m() && n());

      if (is_succeed) {
        this.is_loading = true;
        if (this.is_edit) {
          this.project_params.project_id = this.projectData.type_id;
          updateProjectApi(this.projectData.id, this.project_params).then((res) => {
            this.$message.success(res.message);
            this.$emit('confirm');
          }).finally(() => {
            this.is_loading = false;
          });
        } else {
          createProjectApi(this.project_params).then((res) => {
            this.$message.success(res.message);
            this.$emit('confirm');
          }).finally(() => {
            this.is_loading = false;
          });
        }
      }
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.project_form_config.basic_set_form.config.advertiser_id.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },

    /** 获取资产列表 */
    async getAssetsList(val) {
      const {
        advertiser_id,
        landing_type,
      } = this.project_form_config.basic_set_form.config;
      const { optimize_goal } = this.project_form_config.optimize_form.config;
      const { platform, download_url } = this.project_form_config.target_form.config;

      /** 推广目标是小游戏时，不需要请求资产列表 */
      if (landing_type.value === 'MICRO_GAME') {
        return;
      }
      if (val !== undefined) {
        download_url.value = '';
      }
      return eventManager.getAssetsListApi({
        advertiser_id: advertiser_id.value,
        asset_type: landing_type.value,
        app_type: platform.value,
      }).then((assets_result) => {
        download_url.options = assets_result.list.map(item => {
          return {
            label: item.name,
            value: item.download_url,
            asset_id: item.asset_id,
            app_type: item.app_type,
            package_name: item.package_name,
            package_id: item.package_id,
          };
        });

        optimize_goal.children.asset_ids.options = assets_result.list.map(item => {
          return {
            label: item.asset_name,
            value: item.asset_id,
            package_name: item.package_name,
          };
        });
      });
    },

    // 获取渠道包列表
    getChannelPackageList(params) {
      return new Promise((resolve, reject) => {
        appManagement
          .getChannelPackageListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 同步事件资产
    pullEventAssets(params) {
      return new Promise((resolve, reject) => {
        eventManager
          .pullEventAssetsApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 同步
    pull() {
      const {
        advertiser_id,
        landing_type,
        app_promotion_type,
      } = this.project_form_config.basic_set_form.config;
      this.pull_loading = true;
      eventManager.pullEventAssetsApi({
        advertiser_id: advertiser_id.value,
        asset_type: landing_type.value,
        landing_type: landing_type.value,
        app_promotion_type: app_promotion_type.value,
      }).then((res) => {
        this.pull_loading = false;
        this.$message({
          message: res.message,
          type: 'success',
        });

        this.getAssetsList();
      }).catch(() => {
        this.pull_loading = false;
      });
    },

    // 行为兴趣类型选择
    interestActionChange() {
      const {
        action_days,
        action_scene,
        action_categories,
        interest_categories,
        interest_action_mode,
      } = this.project_form_config.audience_form.config.audience.children;

      const is_custom = interest_action_mode.value === 'CUSTOM';
      action_scene.hidden = !is_custom;
      action_days.hidden = !is_custom;
      action_categories.hidden = !is_custom;
      interest_categories.hidden = !is_custom;
      if (is_custom) {
        action_days.value = '30';
        action_scene.value = ['APP'];
        this.updateInterestAction();
      } else {
        this.resetInterestAction();
      }
    },

    // 重置兴趣行为数据
    resetInterestAction(){
      const show_data = this.project_form_config.audience_form.config.audience.children;
      const arr = ['action_categories', 'action_words', 'interest_categories', 'interest_words'];
      arr.forEach(item => {
        show_data[item].hidden = true;
      });
    },

    // 更新行为兴趣
    updateInterestAction() {
      const {
        action_days,
        action_scene,
        action_categories,
        interest_categories,
      } = this.project_form_config.audience_form.config.audience.children;
      const {
        advertiser_id,
        delivery_mode,
        landing_type,
      } = this.project_form_config.basic_set_form.config;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      action_categories.hidden = true;
      this.interestAction({
        advertiser_id: advertiser_id.value,
        action_scene: action_scene.value,
        action_days: action_days.value,
      }, 'getActionCategoryApi').then((res) => {
        action_categories.options = res.list;
        /** 行为类目词 */
        action_categories.hidden = false;
        if (is_procedural && !delivery_mode.hidden) {
          action_categories.hidden = true;
        }
      });

      interest_categories.hidden = true;
      this.interestAction({
        advertiser_id: advertiser_id.value,
      }, 'getInterestCategoryApi').then((res) => {
        interest_categories.options = res.list;
        /** 兴趣类目词 */
        interest_categories.hidden = false;
        if ((is_micro_game || is_app) && is_procedural && !delivery_mode.hidden) {
          interest_categories.hidden = true;
        }
      });
    },
    // 获取行为兴趣
    interestAction(params, api_key){
      return new Promise((resolve, reject) => {
        interestActionResource[api_key](params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取优化目标 */
    async getOptimizedGoalV2(params) {
      const { external_action, deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
      const { advertiser_id, landing_type, ad_type, asset_type } = params;
      const condition = [!external_action.is_loading, advertiser_id, landing_type, ad_type, asset_type].every(Boolean);
      if (condition) {
        try {
          external_action.is_loading = true;
          const convert_result = await getOptimizedGoalV2Api(params);
          external_action.options = convert_result.goals.map(item => {
            return {
              label: item.optimization_name,
              value: item.external_action,
              deep_goals: item.deep_goals,
              deep_bid_types: item.deep_bid_types,
            };
          });
          const is_valid_value = external_action.options.some(({ value }) => value === external_action.value);
          if (!is_valid_value) {
            external_action.value = '';
            deep_external_action.value = '';
            deep_external_action.hidden = true;
          }
        } finally {
          external_action.is_loading = false;
        }
      }
    },
    /** 重置广告版位表单 */
    resetDeliveryRangeForm() {
      const { delivery_mode } = this.project_form_config.basic_set_form.config;
      this.setInventoryCatalogProperty();
      if (!delivery_mode.hidden) {
        /** 手动执行【投放模式】change事件 */
        delivery_mode?.on?.change?.();
      }
    },
    /** 设置深度转化ROI系数 */
    setRoiGoalProperty() {
      const { delivery_mode, landing_type } = this.project_form_config.basic_set_form.config;
      const { roi_goal, bid_type } = this.project_form_config.delivery_setting_form.config.delivery_setting.children;
      const { deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const is_roi = deep_external_action.value === 'AD_CONVERT_TYPE_PURCHASE_ROI' || deep_external_action.value === 'AD_CONVERT_TYPE_PURCHASE_ROI_7D';
      /** 竞价策略是否是最大转化投放 */
      const is_no_bid = bid_type.value === 'NO_BID';
      /** 当竞价策略(bid_type)为'最大转化投放'时，深度转化ROI系数配置均需要隐藏 */
      /** 深度转化ROI系数, 范围(0,5]，精度：保留小数点后四位，当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME时 && 深度优化目标为付费ROI或付费ROI-7日时必填，当delivery_mode =MANUAL时填写报错 */
      roi_goal.hidden = !(is_procedural && !delivery_mode.hidden && (is_app || is_micro_game) && is_roi && !deep_external_action.hidden && !is_no_bid);
    },
    /** 获取可用深度优化方式 */
    getDeepBidType() {
      return new Promise((resolve, reject) => {
        const { advertiser_id, landing_type, delivery_mode } = this.project_form_config.basic_set_form.config;
        const { external_action, deep_external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
        getDeepBidTypeApi({
          advertiser_id: advertiser_id.value,
          ...(!delivery_mode.hidden && { delivery_mode: delivery_mode.value }),
          landing_type: landing_type.value,
          external_action: external_action.value,
          ...(!deep_external_action.hidden && deep_external_action.value ? { deep_external_action: deep_external_action.value } : {}),
        }).then(resolve).catch(reject);
      });
    },
    /** 设置排期与预算表单项属性 */
    setDeliverySettingFormProperty() {
      const { delivery_mode, landing_type } = this.project_form_config.basic_set_form.config;
      const { budget_mode, bid_type } = this.project_form_config.delivery_setting_form.config.delivery_setting.children;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      /** 当 delivery_mode = PROCEDURAL && landing_type = APP/MICRO_GAME/LINK时仅支持日预算 */
      budget_mode.value = (is_procedural && (is_app || is_micro_game)) ? 'BUDGET_MODE_DAY' : budget_mode.value;
      budget_mode.disabled = !!((is_procedural && !delivery_mode.hidden));
      budget_mode.on?.change?.();
      bid_type.on?.change?.();
    },
    /** 设置定向包表单项属性 */
    setAudienceFormProperty() {
      const {
        device_brand,
        device,
        phone_prices,
        launch_price,
        auto_extend_enabled,
        auto_extend_targets,
        hide_if_exists,
        ac,
        device_type,
        android_osv,
        ios_osv,
        interest_action_mode,
        action_scene,
        action_days,
      } = this.project_form_config.audience_form.config.audience.children;
      const { delivery_mode, landing_type } = this.project_form_config.basic_set_form.config;
      const not_procedural = delivery_mode.value !== 'PROCEDURAL';
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      /** 按品牌选择 */
      const is_choose_brand = device.value === 'CHOOSE_BRAND';

      /** 手机品牌 */
      device.hidden = false;
      device_brand.hidden = !is_choose_brand;

      /** 手机价格 */
      const is_phone_prices_custom = phone_prices.value === 'CUSTOM';
      phone_prices.hidden = false;
      launch_price.hidden = !is_phone_prices_custom;

      /** 智能放量 */
      const is_auto_extend_enabled = auto_extend_enabled.value === 1;
      auto_extend_enabled.hidden = false;
      auto_extend_targets.hidden = !is_auto_extend_enabled;

      /** 过滤已安装 */
      hide_if_exists.hidden = false;
      hide_if_exists.options = [
        { label: '不限', value: 'UNLIMITED', disabled: false },
        { label: '过滤', value: 'FILTER', disabled: false },
        { label: '定向', value: 'TARGETING', disabled: false },
      ];
      /** 网络 */
      ac.hidden = false;
      /** 设备类型 */
      device_type.hidden = false;
      /** 安卓版本 */
      android_osv.hidden = false;
      /** IOS版本 */
      ios_osv.hidden = false;
      /** 行为兴趣 */
      interest_action_mode.hidden = false;
      this.interestActionChange();
      this.project_form_config.audience_form.title = '定向包';
      try {
        const map_tuple = [
          /** 【投放模式】为显示状态 */
          [
            () => !delivery_mode.hidden,
            () => {
              /** 手机品牌 */
              device.hidden = !not_procedural;
              device_brand.hidden = !(not_procedural && is_choose_brand && !device.hidden);

              /** 手机价格 */
              phone_prices.hidden = !not_procedural;
              launch_price.hidden = !(not_procedural && is_phone_prices_custom && !phone_prices.hidden);

              /** 智能放量 */
              auto_extend_enabled.hidden = !not_procedural;
              auto_extend_targets.hidden = !(not_procedural && is_auto_extend_enabled && !auto_extend_enabled.hidden);
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是应用并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_app && is_procedural,
            () => {
              hide_if_exists.options = [
                { label: '不限', value: 'UNLIMITED', disabled: false },
                { label: '过滤', value: 'FILTER', disabled: false },
              ];
              hide_if_exists.value = hide_if_exists.value === 'TARGETING' ? 'UNLIMITED' : hide_if_exists.value;
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是小游戏并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_micro_game && is_procedural,
            () => {
              hide_if_exists.hidden = true;
              android_osv.hidden = true;
              ios_osv.hidden = true;
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是小游戏/应用并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && (is_micro_game || is_app) && is_procedural,
            () => {
              ac.hidden = true;
              device_type.hidden = true;
              interest_action_mode.hidden = true;
              action_scene.hidden = true;
            },
          ],
          /** 【投放模式】为显示状态并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_procedural,
            () => {
              action_days.hidden = true;
              this.project_form_config.audience_form.title = '受众倾向与过滤';
            },
          ],
        ];
        map_tuple.forEach(([condition, handler]) => (condition() && handler()));
      } catch (reason) {
        throw new Error(reason);
      }
    },
    /** 设置深度优化方式属性 */
    setDeepBidTypeProperty() {
      const { deep_bid_type } = this.project_form_config.delivery_setting_form.config.delivery_setting.children;
      const { advertiser_id } = this.project_form_config.basic_set_form.config;
      const { external_action } = this.project_form_config.optimize_form.config.optimize_goal.children;
      if (advertiser_id.value && external_action.value && !deep_bid_type.is_loading) {
        deep_bid_type.is_loading = true;
        this.getDeepBidType().then(res => {
          deep_bid_type.hidden = res.deep_bid_type.length === 0;
          deep_bid_type.options = store.getters.jrttEnum.api_2_deep_bid_type.filter(({ value }) => res.deep_bid_type.includes(value));
          if (!this.is_edit) {
            /** 深度优化方式数据源如果存在【每次付费出价】选项时默认选中【每次付费出价】 */
            deep_bid_type.value = deep_bid_type.options.some(deep => deep.value === 'BID_PER_ACTION') ? 'BID_PER_ACTION' : deep_bid_type.value;
          }
          /** 深度优化方式数据源如果不包含【deep_bid_type.value】则默认选取第一个选项 */
          deep_bid_type.value = deep_bid_type.options.some(deep => deep.value === deep_bid_type.value) ? deep_bid_type.value : deep_bid_type.options[0]?.value;
          deep_bid_type?.on?.change?.();
        }).finally(() => {
          deep_bid_type.is_loading = false;
        });
      }
    },
    /** 设置【广告版位】表单属性 */
    setInventoryCatalogProperty() {
      const { inventory_catalog, inventory_type } = this.project_form_config.delivery_range_form.config.delivery_range.children;
      const { delivery_mode, landing_type } = this.project_form_config.basic_set_form.config;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const all_options = [{ label: '首选媒体', value: 'MANUAL' }, { label: '通投智选', value: 'UNIVERSAL_SMART' }];
      const condition = (is_procedural && !delivery_mode.hidden && (is_micro_game || is_app));
      inventory_catalog.options = condition ? [all_options.at(1)] : [all_options.at(0)];
      inventory_catalog.value = inventory_catalog.options.at(0).value;
      inventory_catalog.on?.change?.();
      inventory_type.on?.change?.();
    },
    /** 获取行政区域列表 */
    getDistrict(advertiser_id) {
      return new Promise((resolve, reject) => {
        getDistrictApi({ advertiser_id, codes: ['CN'], language: 'ZH_CN_GOV', sub_district: 'THREE_LEVEL' }).then(resolve).catch(reject);
      });
    },
    /**
     * 生成行政区域数据所需结构
     * @param {object[]} sources 行政区域源数据
     * @param {object[]} target 行政区域数据所需结构
     */
    generateDistrictsSchema(sources, target) {
      sources.forEach(district => {
        const { code: id, name, sub_districts } = district;
        const temp_data = { id, name, label: name, ...(sub_districts && { children: [] }) };
        target.push(temp_data);
        sub_districts && this.generateDistrictsSchema(sub_districts, temp_data.children);
      });
    },
    /** 更新行政区域数据 */
    async forceUpdateDistrict(advertiser_id) {
      const { city, region_version } = this.project_form_config.audience_form.config.audience.children;
      city.options.splice(0);
      region_version.options.splice(0);
      region_version.value = '';
      const { districts = [], version = [] } = this.districts_map[advertiser_id] || {};
      const copy_districts = clone(districts);
      const copy_version = clone(version);
      region_version.options = copy_version;
      city.options = copy_districts;
      region_version.value = copy_version.at(0)?.value;
    },
    /* 初始化行政区域数据 */
    async initDistrict(advertiser_id) {
      if (!this.districts_map[advertiser_id] && advertiser_id) {
        try {
          const { districts, version } = await this.getDistrict(advertiser_id);
          const [cn_districts] = districts;
          const local_districts = [];
          this.generateDistrictsSchema(cn_districts.sub_districts, local_districts);
          this.$set(this.districts_map, advertiser_id, { districts: local_districts, version: [{ label: version, value: version }] });
        } catch {
          this.$delete(this.districts_map, advertiser_id);
        }
      }
    },
    /** 初始化账号所属的行政区域数据 */
    async initDistrictTasks() {
      const { advertiser_id } = this.project_form_config.basic_set_form.config;
      await this.initDistrict(advertiser_id.value);
      this.forceUpdateDistrict(advertiser_id.value);
    },
    /** 打开小程序资产弹窗 */
    openMiniProgramAssets() {
      const { micro_promotion_type } = this.project_form_config.target_form.config;
      Object.assign(this.mini_program_assets_dialog_config, {
        is_show: true,
        mg_type: micro_promotion_type.value,
      });
    },
    /**
     * 确认小程序资产弹窗
     * @param {Object} data 资产数据
     */
    async miniProgramAssetsConfirm(data) {
      this.mini_program_assets_dialog_config.is_show = false;
      const { micro_app_instance_id } = this.project_form_config.target_form.config;
      micro_app_instance_id.value = JSON.stringify(data);
      this.getMiniOptimizedGoal();
    },
    /** 推广目标为小游戏时获取优化目标 */
    async getMiniOptimizedGoal() {
      const { advertiser_id, ad_type, landing_type, delivery_mode } = this.project_form_config.basic_set_form.config;
      const { micro_promotion_type, micro_app_instance_id } = this.project_form_config.target_form.config;
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const is_wechat_game = is_micro_game && micro_promotion_type.value === 'WECHAT_GAME' && micro_app_instance_id.value;
      const is_byte_game = is_micro_game && micro_promotion_type.value === 'BYTE_GAME' && micro_app_instance_id.value;
      if (is_wechat_game || is_byte_game) {
        await this.getOptimizedGoalV2({
          advertiser_id: advertiser_id.value,
          ad_type: ad_type.value,
          landing_type: landing_type.value,
          asset_type: is_wechat_game ? 'ORANGE' : 'MINI_PROGRAM', // 优化目标为头条V2接口，修正了单词错误
          ...(!delivery_mode?.hidden && { delivery_mode: delivery_mode?.value }),
          micro_app_instance_id: JSON.parse(micro_app_instance_id.value).micro_app_instance_id,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.floor-button {
  position: absolute;
  padding: 20px;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: right;
  z-index: 99;
  border-top: 1px solid #ccc;
  background-color: #fff;
}

.outer-layer {
  height: calc(100% - 60px);
  overflow: hidden scroll;
}

/deep/.launch-style {
  overflow: hidden;
}

</style>
